// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { type CSSProperties, useCallback, useState } from 'react';

const VISUALLY_HIDDEN: CSSProperties = {
  blockSize: 1,
  clipPath: 'inset(50%)',
  inlineSize: 1,
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
};

const LINE: CSSProperties = { display: 'block' };

export const useStatusAnnouncer = () => {
  const [entry, setEntry] = useState<{ id: number; lines: readonly string[] }>({
    id: 0,
    lines: [],
  });
  const announce = useCallback(
    (...lines: string[]) => setEntry(prev => ({ id: prev.id + 1, lines })),
    [],
  );
  const region = (
    <output aria-live="polite" style={VISUALLY_HIDDEN}>
      <span key={entry.id}>
        {entry.lines.map((line, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: the keyed parent replaces every line together
          <span key={i} style={LINE}>
            {line}
          </span>
        ))}
      </span>
    </output>
  );
  return [announce, region] as const;
};
